import React from 'react';
import styles from './LegendMapOverlay.module.css';

import { Panel } from '@ixicare/ui';
import { t } from '~i18n';

export const LegendMapOverlay = () => {
  return (
    <Panel className={styles.LegendMapOverlay}>
      <Panel.Title>{t('legend.overlay.title')}</Panel.Title>
      <Panel.Section>
        <dl>
          <div className={styles.DeviceBatteryFull}></div>
          <p>{t('legend.overlay.batteryFull')}</p>
        </dl>
        <dl>
          <div className={styles.DeviceBatteryHalf}></div>
          <p>{t('legend.overlay.batteryNearEmpty')}</p>
        </dl>
        <dl>
          <div className={styles.DeviceBatteryEmpty}></div>
          <p>{t('legend.overlay.batteryEmpty')}</p>
        </dl>
        <dl>
          <div className={styles.DeviceNotSeen}></div>
          <p>{t('legend.overlay.deviceNotConnected')}</p>
        </dl>
      </Panel.Section>
    </Panel>
  );
};
